import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getExport } from './actions'

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getExport }, dispatch)
}

export default function (InnerComponent) {
    @connect(null, mapDispatchToProps)
    class HocExports extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocExports
}
